"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.List = exports.shallowDiffers = void 0;
var React = require("react");
var classNames = require("classnames");
var memoize_one_1 = require("memoize-one");
var __1 = require("../");
var viewportConstants_1 = require("../../viewportConstants");
var DEFAULT_SCROLLBAR_WIDTH = 16;
function defaultItemKey(index, data, forceUpdate) {
    return (index.toString() +
        (forceUpdate !== undefined ? '-' + forceUpdate.toString() : ''));
}
var now = typeof performance === 'object' && typeof performance.now === 'function'
    ? function () { return performance.now(); }
    : function () { return Date.now(); };
function cancelTimeout(timeoutID) {
    cancelAnimationFrame(timeoutID.id);
}
function requestTimeout(callback, delay) {
    var start = now();
    var timeoutID = {
        id: requestAnimationFrame(tick)
    };
    function tick() {
        if (now() - start >= delay) {
            callback.call(null);
        }
        else {
            timeoutID.id = requestAnimationFrame(tick);
        }
    }
    return timeoutID;
}
function shallowDiffers(prev, next) {
    for (var attribute in prev) {
        if (!(attribute in next)) {
            return true;
        }
    }
    for (var attribute in next) {
        if (prev[attribute] !== next[attribute]) {
            return true;
        }
    }
    return false;
}
exports.shallowDiffers = shallowDiffers;
var SCROLL_TIMEOUT = 180;
var THUMB_MIN_SIZE = 16;
var ARROW_HEIGHT = 16;
var ARROW_WIDTH = 16;
var Scrollbar = /** @class */ (function (_super) {
    __extends(Scrollbar, _super);
    function Scrollbar(props) {
        var _this = _super.call(this, props) || this;
        _this.reference = undefined;
        _this.thumbReference = undefined;
        _this.trackReference = undefined;
        _this.__trackPosition = 0;
        _this.__mouseDownPosition = 0;
        _this.__isDragging = false;
        _this.__mouseDown = function (e) {
            var _a = _this.props, alignment = _a.alignment, offset = _a.offset;
            var reference = _this.reference;
            e.stopPropagation();
            if (!reference) {
                return;
            }
            _this.__isDragging = true;
            _this.__trackPosition = offset;
            _this.__mouseDownPosition = alignment === 'VERTICAL' ? e.clientY : e.clientX;
            document.onmousemove = document.ontouchmove = _this.__mouseMove;
            document.onmouseup = document.ontouchend = _this.__mouseUp;
        };
        _this.__mouseMove = function (e) {
            var _a = _this.props, alignment = _a.alignment, ratio = _a.ratio, scrollAreaReference = _a.scrollAreaReference;
            var _b = _this.state, trackSize = _b.trackSize, thumbSize = _b.thumbSize;
            e.preventDefault();
            if (!scrollAreaReference || !scrollAreaReference.current) {
                return;
            }
            if (_this.__isDragging) {
                var newPosition = alignment === 'HORIZONTAL' ? e.clientX : e.clientY;
                var d = newPosition - _this.__mouseDownPosition;
                var contentHeight = trackSize / ratio;
                var trackSpace = contentHeight - trackSize;
                var thumbSpace = trackSize - thumbSize;
                var scrollJump = trackSpace / thumbSpace; // thumb to track ratio
                if (alignment === 'HORIZONTAL') {
                    scrollAreaReference.current.scrollLeft =
                        _this.__trackPosition + d * scrollJump;
                }
                else if (alignment === 'VERTICAL') {
                    scrollAreaReference.current.scrollTop =
                        _this.__trackPosition + d * scrollJump;
                }
            }
        };
        _this.__mouseUp = function (e) {
            _this.__trackPosition = 0;
            _this.__isDragging = false;
            document.onmousemove = document.ontouchmove = null;
            document.onmouseup = document.ontouchend = null;
        };
        _this.state = {
            thumbSize: 0,
            trackSize: 0
        };
        _this.reference = React.createRef();
        _this.thumbReference = React.createRef();
        _this.trackReference = React.createRef();
        return _this;
    }
    Scrollbar.prototype.componentDidMount = function () {
        if (this.props.alignment === 'HORIZONTAL') {
            var scrollbarArea_1 = this.props.width - ARROW_WIDTH * 2;
            var thumbWidth_1 = Math.max(THUMB_MIN_SIZE, scrollbarArea_1 * this.props.ratio);
            this.setState(function () { return ({
                thumbSize: thumbWidth_1,
                trackSize: scrollbarArea_1
            }); });
        }
        if (this.props.alignment === 'VERTICAL') {
            var scrollbarArea_2 = this.props.height - ARROW_HEIGHT * 2;
            var thumbHeight_1 = Math.max(THUMB_MIN_SIZE, scrollbarArea_2 * this.props.ratio);
            this.setState(function () { return ({
                thumbSize: thumbHeight_1,
                trackSize: scrollbarArea_2
            }); });
        }
        if (this.thumbReference && this.thumbReference.current) {
            this.thumbReference.current.addEventListener('mousedown', this.__mouseDown.bind(this), { passive: true });
            this.thumbReference.current.addEventListener('touchstart', this.__mouseDown.bind(this), { passive: true });
        }
    };
    Scrollbar.prototype.componentWillUnmount = function () {
        if (this.thumbReference && this.thumbReference.current) {
            this.thumbReference.current.removeEventListener('mousedown', this.__mouseDown.bind(this));
            this.thumbReference.current.removeEventListener('touchstart', this.__mouseDown.bind(this));
        }
    };
    Scrollbar.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.alignment === 'VERTICAL') {
            var scrollbarArea_3 = nextProps.height - ARROW_HEIGHT * 2;
            var thumbHeight_2 = Math.max(THUMB_MIN_SIZE, scrollbarArea_3 * nextProps.ratio);
            this.setState(function () { return ({
                thumbSize: thumbHeight_2,
                trackSize: scrollbarArea_3
            }); });
        }
        if (nextProps.alignment === 'HORIZONTAL') {
            var scrollbarArea_4 = nextProps.width - ARROW_WIDTH * 2;
            var thumbWidth_2 = Math.max(THUMB_MIN_SIZE, scrollbarArea_4 * nextProps.ratio);
            this.setState(function () { return ({
                thumbSize: thumbWidth_2,
                trackSize: scrollbarArea_4
            }); });
        }
    };
    Scrollbar.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        if (!shallowDiffers(nextProps, this.props) &&
            !shallowDiffers(nextState, this.state)) {
            return false;
        }
        return true;
    };
    Scrollbar.prototype.render = function () {
        var _a = this.props, alignment = _a.alignment, offset = _a.offset, ratio = _a.ratio, style = _a.style, scrollAreaReference = _a.scrollAreaReference;
        var _b = this.state, thumbSize = _b.thumbSize, trackSize = _b.trackSize;
        var _c = this, reference = _c.reference, thumbReference = _c.thumbReference, trackReference = _c.trackReference;
        // calculate thumb position related on trackspace
        var leftOffset = offset * ratio;
        var maxSize = Math.max(0, trackSize - thumbSize);
        var pos = Math.max(0, Math.min(leftOffset, maxSize));
        var arrowHeight = alignment === 'VERTICAL' ? ARROW_HEIGHT : '100%';
        var arrowWidth = alignment === 'HORIZONTAL' ? ARROW_HEIGHT : '100%';
        return (React.createElement("div", { className: classNames('scrollbar', alignment === 'VERTICAL'
                ? 'scrollbar-vertical'
                : 'scrollbar-horizontal'), style: __assign({ height: alignment === 'VERTICAL'
                    ? this.props.height || ARROW_WIDTH
                    : undefined, width: alignment === 'HORIZONTAL'
                    ? this.props.width || ARROW_HEIGHT
                    : undefined }, style), ref: reference },
            React.createElement("div", { className: 'button', style: { width: arrowWidth, height: arrowHeight } },
                React.createElement(__1.Icon, { className: alignment === 'VERTICAL' ? 'fa-chevron-up' : 'fa-chevron-left', onClick: function () {
                        if (alignment === 'VERTICAL') {
                            scrollAreaReference.current.scrollTop -= 50;
                        }
                        else if (alignment === 'HORIZONTAL') {
                            scrollAreaReference.current.scrollLeft -= 50;
                        }
                    } })),
            React.createElement("div", { className: 'track', ref: trackReference, onClick: function (e) {
                    var rect = thumbReference.current.getBoundingClientRect();
                    var _a = scrollAreaReference.current, scrollLeft = _a.scrollLeft, scrollTop = _a.scrollTop;
                    if (alignment === 'HORIZONTAL') {
                        if (rect.left > e.clientX) {
                            scrollAreaReference.current.scrollLeft = Math.max(0, scrollLeft - rect.width / ratio);
                        }
                        else if (rect.right < e.clientX) {
                            scrollAreaReference.current.scrollLeft = Math.max(rect.width, scrollLeft + rect.width / ratio);
                        }
                    }
                    else if (alignment === 'VERTICAL') {
                        if (rect.top > e.clientY) {
                            scrollAreaReference.current.scrollTop = Math.max(0, scrollTop - rect.height / ratio);
                        }
                        else if (rect.bottom < e.clientY) {
                            scrollAreaReference.current.scrollTop = Math.max(rect.height, scrollTop + rect.height / ratio);
                        }
                    }
                }, style: {
                    height: alignment === 'VERTICAL' ? trackSize : undefined,
                    width: alignment === 'HORIZONTAL' ? trackSize : undefined
                } },
                React.createElement("div", { className: 'thumb', onClick: function (e) { return e.stopPropagation(); }, ref: thumbReference, style: {
                        top: alignment === 'VERTICAL' ? pos : undefined,
                        left: alignment === 'HORIZONTAL' ? pos : undefined,
                        width: alignment === 'HORIZONTAL' ? thumbSize : '100%',
                        height: alignment === 'VERTICAL' ? thumbSize : '100%'
                    } })),
            React.createElement("div", { className: 'button', style: { width: arrowWidth, height: arrowHeight } },
                React.createElement(__1.Icon, { className: alignment === 'VERTICAL' ? 'fa-chevron-down' : 'fa-chevron-right', onClick: function () {
                        if (alignment === 'VERTICAL') {
                            scrollAreaReference.current.scrollTop += 50;
                        }
                        else if (alignment === 'HORIZONTAL') {
                            scrollAreaReference.current.scrollLeft += 50;
                        }
                    } }))));
    };
    Scrollbar.defaultProps = {
        offset: 0,
        ratio: 1
    };
    return Scrollbar;
}(React.Component));
function createVirtualizedList(_a) {
    var _b;
    var getItemOffset = _a.getItemOffset, getItemStartIndex = _a.getItemStartIndex, getItemEndIndex = _a.getItemEndIndex, getItemHeight = _a.getItemHeight, getItemWidth = _a.getItemWidth, getTotalHeight = _a.getTotalHeight, getTotalWidth = _a.getTotalWidth;
    return _b = /** @class */ (function (_super) {
            __extends(List, _super);
            function List(props) {
                var _this = _super.call(this, props) || this;
                _this.outerRef = undefined;
                _this.innerRef = undefined;
                _this.__resetIsScrollingTimeoutId = null;
                _this.__styleCache = {};
                _this.state = {
                    instance: _this,
                    offsetTop: 0,
                    offsetLeft: 0,
                    scrollDirection: 'DOWN',
                    isScrolling: false
                };
                _this.__callOnItemsRendered = (0, memoize_one_1.default)(function (overscanStartIndex, overscanEndIndex, startIndex, endIndex) {
                    if (typeof _this.props.onItemsRendered === 'function') {
                        _this.props.onItemsRendered({
                            overscanStartIndex: overscanStartIndex,
                            overscanEndIndex: overscanEndIndex,
                            visibleStartIndex: startIndex,
                            visibleEndIndex: endIndex
                        });
                    }
                });
                _this.__callOnScroll = (0, memoize_one_1.default)(function (scrollDirection, offset) {
                    if (typeof _this.props.onScroll === 'function') {
                        _this.props.onScroll({ scrollDirection: scrollDirection, offset: offset });
                    }
                });
                _this.outerRef = React.createRef();
                _this.innerRef = React.createRef();
                return _this;
            }
            List.prototype.componentDidMount = function () {
                this.__propsCallback();
            };
            List.prototype.componentDidUpdate = function (prevProps) {
                if (this.props.itemWidth !== prevProps.itemWidth ||
                    this.props.itemHeight !== prevProps.itemHeight ||
                    this.props.headerHeight !== prevProps.headerHeight) {
                    this.__styleCache = {};
                    this.setState(__assign(__assign({}, this.state), { forceUpdate: Date.now() }));
                }
                this.__propsCallback();
            };
            List.prototype.componentWillUnmount = function () {
                if (this.__resetIsScrollingTimeoutId !== null) {
                    cancelTimeout(this.__resetIsScrollingTimeoutId);
                }
            };
            List.prototype.shouldComponentUpdate = function (nextProps, nextState) {
                if (!shallowDiffers(nextProps, this.props) &&
                    !shallowDiffers(nextState, this.state)) {
                    return false;
                }
                return true;
            };
            List.prototype.render = function () {
                var _a = this.props, children = _a.children, placeholder = _a.placeholder, header = _a.header, className = _a.className, width = _a.width, height = _a.height, headerHeight = _a.headerHeight, itemHeight = _a.itemHeight, itemCount = _a.itemCount, itemData = _a.itemData /* pointer to the beginning of item data array */, _c = _a.itemKey, itemKey = _c === void 0 ? defaultItemKey : _c, style = _a.style;
                var _d = this, outerRef = _d.outerRef, innerRef = _d.innerRef;
                var _e = this.state, offsetLeft = _e.offsetLeft, offsetTop = _e.offsetTop;
                var _f = this.__getRangeToRender(), startIndex = _f[0], endIndex = _f[1];
                var onScroll = this.__onScroll.bind(this);
                var estimatedTotalSize = getTotalHeight(this.props, undefined) || 1;
                var estimatedTotalWidth = getTotalWidth(this.props, undefined) || 0;
                var items = [];
                var topPadding = header ? (headerHeight ? headerHeight : itemHeight) : 0;
                if (itemCount > 0) {
                    for (var index = startIndex; index <= endIndex; index++) {
                        var style_1 = this.__getItemStyle(index);
                        items.push(React.createElement(children, {
                            className: 'row',
                            data: itemData,
                            key: itemKey(index, itemData, this.state.forceUpdate),
                            index: index,
                            style: style_1
                        }));
                    }
                }
                var verticalScrollWidth = 0;
                var horizontalScrollHeight = 0;
                var scrollAreaWidth = width;
                var scrollAreaHeight = placeholder && items.length === 0
                    ? 280
                    : Math.min(estimatedTotalSize, Math.max(topPadding, height - topPadding));
                var hasVerticalScrollbar = estimatedTotalSize > scrollAreaHeight;
                var hasHorizontalScrollbar = estimatedTotalWidth > scrollAreaWidth;
                if (outerRef.current) {
                    verticalScrollWidth = !hasVerticalScrollbar
                        ? 0
                        : Math.max(DEFAULT_SCROLLBAR_WIDTH, outerRef.current.offsetWidth - outerRef.current.clientWidth);
                    horizontalScrollHeight = !hasHorizontalScrollbar
                        ? 0
                        : outerRef.current.clientHeight === 0
                            ? DEFAULT_SCROLLBAR_WIDTH
                            : Math.max(DEFAULT_SCROLLBAR_WIDTH, outerRef.current.offsetHeight - outerRef.current.clientHeight);
                }
                else {
                    verticalScrollWidth = !hasVerticalScrollbar
                        ? 0
                        : DEFAULT_SCROLLBAR_WIDTH;
                    horizontalScrollHeight = !hasHorizontalScrollbar
                        ? 0
                        : DEFAULT_SCROLLBAR_WIDTH;
                }
                var scrollPadding = horizontalScrollHeight;
                var ratioHorizontal = (scrollAreaWidth - verticalScrollWidth) / estimatedTotalWidth || 0;
                var ratioVertical = (scrollAreaHeight - horizontalScrollHeight) / estimatedTotalSize || 0;
                return React.createElement('div', {
                    style: __assign({ width: width, height: scrollAreaHeight + scrollPadding + topPadding }, style),
                    key: 'list',
                    className: classNames('sok-list', className)
                }, [
                    header &&
                        React.cloneElement(header, {
                            className: 'header',
                            key: 'header',
                            style: {
                                position: 'absolute',
                                top: 0,
                                right: 0,
                                left: -offsetLeft,
                                width: Math.max(estimatedTotalWidth, scrollAreaWidth) +
                                    verticalScrollWidth,
                                height: topPadding
                            }
                        }),
                    items.length === 0 &&
                        placeholder &&
                        React.cloneElement(placeholder, {
                            key: 'placeholder',
                            style: {
                                position: 'absolute',
                                display: 'flex',
                                top: header && topPadding,
                                left: 0,
                                alignItems: 'center',
                                justifyContent: 'center',
                                width: width,
                                maxHeight: scrollAreaHeight + scrollPadding
                            }
                        }),
                    React.createElement('div', {
                        key: 'viewport',
                        className: 'viewport',
                        ref: outerRef,
                        onScroll: onScroll,
                        style: {
                            top: header && topPadding,
                            width: width,
                            height: scrollAreaHeight +
                                (navigator.userAgent.toLowerCase().indexOf('firefox') > -1
                                    ? 0
                                    : hasHorizontalScrollbar
                                        ? scrollPadding
                                        : scrollPadding + 2)
                        }
                    }, React.createElement('div', {
                        className: classNames('overview', this.props.striped !== false ? 'striped' : ''),
                        children: items,
                        ref: innerRef,
                        key: 'overview',
                        style: {
                            // pointerEvents: isScrolling ? 'none' : undefined,
                            // userSelect: isScrolling ? 'none' : undefined,
                            height: estimatedTotalSize,
                            width: Math.max(estimatedTotalWidth, width - verticalScrollWidth)
                        }
                    })),
                    hasHorizontalScrollbar &&
                        React.createElement(Scrollbar, {
                            key: 'scroll-horizontal',
                            scrollAreaReference: outerRef,
                            style: { bottom: 0, height: horizontalScrollHeight },
                            alignment: 'HORIZONTAL',
                            ratio: ratioHorizontal,
                            offset: offsetLeft,
                            width: hasVerticalScrollbar
                                ? scrollAreaWidth - verticalScrollWidth
                                : scrollAreaWidth
                        }),
                    hasVerticalScrollbar &&
                        React.createElement(Scrollbar, {
                            key: 'scroll-vertical',
                            scrollAreaReference: outerRef,
                            style: {
                                top: topPadding,
                                right: 0,
                                bottom: horizontalScrollHeight,
                                width: verticalScrollWidth
                            },
                            alignment: 'VERTICAL',
                            ratio: ratioVertical,
                            offset: offsetTop,
                            height: scrollAreaHeight
                        })
                ]);
            };
            List.prototype.__onScroll = function (e) {
                var _a = e.currentTarget, clientHeight = _a.clientHeight, clientWidth = _a.clientWidth, scrollHeight = _a.scrollHeight, scrollWidth = _a.scrollWidth, scrollTop = _a.scrollTop, scrollLeft = _a.scrollLeft;
                this.setState(function (prevState) {
                    if (prevState.offsetTop === scrollTop &&
                        prevState.offsetLeft === scrollLeft) {
                        return null;
                    }
                    var direction = 'DOWN';
                    if (prevState.offsetTop > scrollTop) {
                        direction = 'UP';
                    }
                    var scrollTopOffset = Math.max(0, Math.min(scrollTop, scrollHeight - clientHeight));
                    var scrollLeftOffset = Math.max(0, Math.min(scrollLeft, scrollWidth - clientWidth));
                    return {
                        isScrolling: true,
                        scrollDirection: direction,
                        offsetTop: scrollTopOffset,
                        offsetLeft: scrollLeftOffset
                    };
                }, this.__resetIsScrollingDebounced);
            };
            List.prototype.__getRangeToRender = function () {
                var _a = this.props, itemCount = _a.itemCount, overscanCount = _a.overscanCount;
                var _c = this.state, scrollDirection = _c.scrollDirection, offsetTop = _c.offsetTop;
                if (itemCount === 0) {
                    return [0, 0, 0, 0];
                }
                var startIndex = getItemStartIndex(this.props, offsetTop, undefined);
                var endIndex = getItemEndIndex(this.props, startIndex, offsetTop, undefined);
                var overscanBackward = scrollDirection === 'UP' ? Math.max(1, overscanCount) : 1;
                var overscanForward = scrollDirection === 'DOWN' ? Math.max(1, overscanCount) : 1;
                return [
                    Math.max(0, startIndex - overscanBackward),
                    Math.max(0, Math.min(itemCount - 1, endIndex + overscanForward)),
                    startIndex,
                    endIndex
                ];
            };
            List.prototype.__getItemStyle = function (index) {
                var style = this.__styleCache[index];
                if (!style) {
                    var offset = getItemOffset(this.props, index, undefined);
                    var height = getItemHeight(this.props, index, undefined);
                    var width = getItemWidth(this.props, index);
                    style = {
                        position: 'absolute',
                        top: offset,
                        maxWidth: width,
                        height: height,
                        width: width
                    };
                    this.__styleCache[index] = style;
                }
                return style;
            };
            List.prototype.__propsCallback = function () {
                var _a = this.__getRangeToRender(), overscanStartIndex = _a[0], overscanEndIndex = _a[1], startIndex = _a[2], endIndex = _a[3];
                this.__callOnItemsRendered(overscanStartIndex, overscanEndIndex, startIndex, endIndex);
                this.__callOnScroll(this.state.scrollDirection, this.state.offsetTop);
            };
            List.prototype.__resetIsScrolling = function () {
                this.__resetIsScrollingTimeoutId = null;
                this.setState({ isScrolling: false }, function () {
                    /* Hökäle */
                });
            };
            List.prototype.__resetIsScrollingDebounced = function () {
                if (this.__resetIsScrollingTimeoutId !== null) {
                    cancelTimeout(this.__resetIsScrollingTimeoutId);
                }
                this.__resetIsScrollingTimeoutId = requestTimeout(this.__resetIsScrolling.bind(this), SCROLL_TIMEOUT);
            };
            return List;
        }(React.Component)),
        _b.defaultProps = {
            overscanCount: 2
        },
        _b;
}
exports.List = createVirtualizedList({
    getItemOffset: function (_a, index) {
        var itemHeight = _a.itemHeight, header = _a.header;
        return index * itemHeight;
    },
    getItemHeight: function (_a, index) {
        var itemHeight = _a.itemHeight;
        return itemHeight;
    },
    getItemWidth: function (_a) {
        var itemWidth = _a.itemWidth, width = _a.width, viewportSize = _a.viewportSize;
        if (viewportSize === 'TABLET' && window.innerWidth < viewportConstants_1.tabletBreakpoint) {
            return 800;
        }
        return itemWidth || width;
    },
    getTotalWidth: function (_a) {
        var itemWidth = _a.itemWidth, width = _a.width, viewportSize = _a.viewportSize;
        if (viewportSize === 'TABLET' && window.innerWidth < viewportConstants_1.tabletBreakpoint) {
            return 800;
        }
        return itemWidth || width;
    },
    getTotalHeight: function (_a) {
        var itemHeight = _a.itemHeight, itemCount = _a.itemCount;
        return itemHeight * itemCount;
    },
    getItemStartIndex: function (_a, offset) {
        var itemCount = _a.itemCount, itemHeight = _a.itemHeight;
        return Math.max(0, Math.min(itemCount - 1, Math.floor(offset / itemHeight)));
    },
    getItemEndIndex: function (_a, startIndex, offsetTop) {
        var itemHeight = _a.itemHeight, itemCount = _a.itemCount, height = _a.height, width = _a.width;
        var heightOffset = startIndex * itemHeight;
        var nOfVisibleItems = Math.ceil((height + offsetTop - heightOffset) / itemHeight);
        return Math.max(0, Math.min(itemCount - 1, startIndex + nOfVisibleItems - 1));
    }
});
//# sourceMappingURL=index.js.map